module.exports = __webpack_public_path__ + "static/media/PR_55_07.ec7a7aa5.jpg";